import { Container } from '@mui/material';
import { AuditsInProgressTable } from './AuditsInProgressTable';
import { AuditsInQueueTable } from './AuditsInQueueTable';
import { useAuditQueue } from './useAuditQueue';
import { Loader, usePagination } from '@shared';

export function AuditQueue() {
  const [page, setPage] = usePagination();
  const { data, isLoading, isFetching, isError } = useAuditQueue(page);

  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return null;
  }

  return (
    <Container component='article' sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
      {data.auditExamSessionList.length > 0 && (
        <AuditsInProgressTable auditsInProgress={data.auditExamSessionList} />
      )}
      <AuditsInQueueTable
        auditsInQueue={data.examSessions}
        totalResults={data.totalResults}
        isFetching={isFetching}
        onPageChange={setPage}
      />
    </Container>
  );
}
